import request from '@/utils/request'


// 查询用户领券/发放记录列表
export function listCouponUser(query) {
  return request({
    url: '/coupon/coupon/user/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询用户领券/发放记录分页
export function pageCouponUser(query) {
  return request({
    url: '/coupon/coupon/user/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询用户领券/发放记录详细
export function getCouponUser(data) {
  return request({
    url: '/coupon/coupon/user/detail',
    method: 'get',
    params: data
  })
}

// 新增用户领券/发放记录
export function addCouponUser(data) {
  return request({
    url: '/coupon/coupon/user/add',
    method: 'post',
    data: data
  })
}

// 修改用户领券/发放记录
export function updateCouponUser(data) {
  return request({
    url: '/coupon/coupon/user/edit',
    method: 'post',
    data: data
  })
}

// 删除用户领券/发放记录
export function delCouponUser(data) {
  return request({
    url: '/coupon/coupon/user/delete',
    method: 'post',
    data: data
  })
}
